import React from 'react'

function Footer() {
    return (
        <footer className="App-footer">
                <b>Not Working? <a href="http://dnd-api-resource.herokuapp.com">Click Here</a></b>
        </footer>
    )
}

export default Footer